import {
  apiGetRequest,
  apiPostRequest,
  cdnGetRequest,
} from "../utils/webrequests";
import { UserProfile } from "../data/userProfile";
import { UserInfo } from "../data/userInfo";

export async function getUser(CurrentId: string): Promise<UserProfile> {
  const data: UserProfile = await apiGetRequest("GetUser?id=" + CurrentId, null);
  return data;
}

export async function saveUser(SaveUser: string): Promise<any> {
  const data: UserProfile = await apiPostRequest("UpdateUser", SaveUser);
  return data;
}

export async function getUsers(): Promise<UserInfo[]> {
  try {
    const data: UserInfo[] | undefined = await apiGetRequest("GetUsers", null);
    if (!data) {
      throw new Error("No data received from API");
    }
    return data;
  } catch (error: any) {
    throw new Error("Error fetching event info: " + error.message);
  }
}

export async function getRegisteredUsers(eventId: string): Promise<UserInfo[]> {
  const response = await fetch(`http://localhost:7071/api/events/${eventId}/users`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch registered users: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function markUserAsCheckedIn(eventId: string, userId: string) {
  const response = await fetch(`http://localhost:7071/api/events/${eventId}/users/${userId}/checkin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to check in user");
  }
}

